import { Component, OnInit } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { ActivatedRoute, Router } from '@angular/router';
import { TypesService } from '../types.service';

@Component({
  selector: 'app-type',
  templateUrl: './type.component.html',
  styleUrls: ['./type.component.css']
})
export class TypeComponent implements OnInit {
  typeForm: DVFormGroup;
  isAddState = true;
  constructor(
    private typeApi: TypesService,
    private notifier: SnotifyService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    if (this.route.snapshot.params[`id`]) {
      this.isAddState = false;
      this.typeApi.getTypeById(this.route.snapshot.params.id).subscribe((Response)=>{
        console.log(Response , 'ssssssssss');
        this.typeForm.patchValue(Response.data.tagGroup);
      });
    } else {
      this.isAddState = true;
    }
    this.typeForm = new DVFormGroup({
      name: new DVFormControl(null, {
        'Name  is required': Validators.required
      })
    });
  }

  ngOnInit() {}
  SubmitForm() {
    if (this.typeForm.valid) {
      this.typeApi.addType(this.typeForm.value).subscribe(Response => {
        this.notifier.success('Type Has Added Successfully');
        this.router.navigateByUrl('/filters/type/list');
        this.typeForm.reset();
      });
    } else {
      this.typeForm.forceShowErrors();
    }
  }
  EditForm() {
    if (this.typeForm.valid) {
      console.log(this.typeForm.value, this.route.snapshot.params.id);
    this.typeApi.editType({name: this.typeForm.value.name , id: this.route.snapshot.params.id}, this.route.snapshot.params.id).subscribe((Response) => {
      console.log(Response);
      this.notifier.success('Type Edited Successfully');
      this.router.navigateByUrl('/filters/type/list');
    }, err => {
      this.notifier.error(err.error.userMessage);
    });
   } else {
    this.typeForm.forceShowErrors();
  }
  }
  CancelForm() {
    this.router.navigateByUrl('/filters/type/add');
  }
}
